import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { TopicsURL, TopicsURLSearchParam } from '../models';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TopicsURLService {

  private path = '/topics_urls';

  constructor(private http: AlloxApiService) { }

  public search(param?: TopicsURLSearchParam) {
    let url = this.path;
    if (param) {
      url += param.toURLQuery();
    }
    return this.http.get<[]>(url).pipe(
      map(objs => objs.map(obj => new TopicsURL(obj))),
    );
  }

  public fetch(platformId: number) {
    return this.http.get(this.path + '/' + platformId).pipe(
      map(obj => new TopicsURL(obj))
    );
  }
  public post(item: TopicsURL) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: TopicsURL) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.platformId, json);
  }
}
